export { default } from './Slogan';
